import { render, staticRenderFns } from "./sliderBar.vue?vue&type=template&id=130969bc&scoped=true&"
import script from "./sliderBar.vue?vue&type=script&lang=js&"
export * from "./sliderBar.vue?vue&type=script&lang=js&"
import style0 from "./sliderBar.vue?vue&type=style&index=0&id=130969bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130969bc",
  null
  
)

export default component.exports